<template>
  <page-wrapper
    ref="pageEl"
    class="subscriber-report-page"
    title="Subscriber Report Page"
  >
    <div class="page-container">
      <LoadingOverlay :active="isLoading" />

      <section class="report-filter">
        <div class="form">
          <div class="section">
            <div class="report-filters__field report-filters__field--span-2">
              <div class="label">วันที่</div>
              <date-picker
                v-model="dateRange"
                class="report-filters__control"
                :disabled="!isDropdownDisabled"
                type="daterange"
              ></date-picker>
            </div>
            <div class="report-filters__field">
              <div class="label">ประเภทวัน</div>
              <el-select
                v-model="query.dateType"
                class="report-filters__control"
                :disabled="!isDropdownDisabled"
                clearable
              >
                <el-option
                  v-for="t in filterDate"
                  :key="t.value"
                  :label="t.label"
                  :value="t.value"
                ></el-option>
              </el-select>
            </div>
            <div class="report-filters__field">
              <div class="label">สถานะ</div>
              <el-select
                v-model="query.status"
                class="report-filters__control"
                :disabled="!isDropdownDisabled"
                clearable
              >
                <el-option
                  v-for="t in filterStatus"
                  :key="t.value"
                  :label="t.label"
                  :value="t.value"
                ></el-option>
              </el-select>
            </div>
            <div class="report-filters__field">
              <div class="label">ประเภท</div>
              <el-select
                v-model="query.type"
                class="report-filters__control"
                :disabled="!isDropdownDisabled"
                clearable
              >
                <el-option
                  v-for="t in filterType"
                  :key="t.value"
                  :label="t.label"
                  :value="t.value"
                ></el-option>
              </el-select>
            </div>
            <div class="report-filters__field">
              <div class="label">หมวดหมู่</div>
              <el-select
                v-model="query.category"
                class="report-filters__control"
                :disabled="!isDropdownDisabled"
                clearable
              >
                <el-option
                  v-for="t in filterCategory"
                  :key="t.value"
                  :label="t.label"
                  :value="t.value"
                ></el-option>
              </el-select>
            </div>
            <div class="report-filters__field report-filters__field--span-2">
              <div class="label">ค้นหาโครงการ</div>
              <project-select
                v-model="selectedProject"
                class="report-filters__control"
                :disabled="!isDropdownDisabled"
              ></project-select>
            </div>
            <div class="report-filters__field">
              <div class="label">ประเภทเอกสาร</div>
              <el-select
                v-model="query.receiptTypeTH"
                class="report-filters__control"
                :disabled="!isDropdownDisabled"
                clearable
              >
                <el-option
                  v-for="t in filterReceiptType"
                  :key="t.value"
                  :label="t.label"
                  :value="t.value"
                ></el-option>
              </el-select>
            </div>
            <div class="report-filters__field">
              <div class="label">ประเภทบริษัท</div>
              <el-select
                v-model="query.companyType"
                class="report-filters__control"
                :disabled="!isDropdownDisabled"
                clearable
              >
                <el-option
                  v-for="t in filterCompanyType"
                  :key="t.value"
                  :label="t.label"
                  :value="t.value"
                ></el-option>
              </el-select>
            </div>
            <div class="report-filters__field report-filters__field--full">
              <div class="label">เลขที่เอกสาร/Subscription ID</div>
              <el-input
                v-model="query.documentNumber"
                class="report-filters__control"
                :disabled="!isSearchDisabled"
                type="textarea"
                rows="3"
                placeholder="ใส่ , คั่นเลขเอกสาร (Ex: 2019010001,2019010002)"
              ></el-input>
            </div>
          </div>
          <div class="report-filters__options">
            <el-checkbox
              v-model="isFilteredByMNC"
              @change="handleClickSearch"
            >
              <span class="checkbox-font">รายการที่ใช้ MNC</span>
            </el-checkbox>
          </div>
          <div class="report-filters__actions">
            <el-button
              class="report-filters__action-btn report-filters__action-btn--search"
              type="primary"
              :disabled="!isSearchDisabled"
              @click="handleClickSearch"
            >ค้นหา</el-button>
            <el-button
              class="report-filters__action-btn report-filters__action-btn--download"
              type="info"
              :disabled="!isClickDownloadAsCSVDisabled"
              @click.prevent="handleClickDownloadAsCSV"
            >
              Download
            </el-button>
            <el-button
              class="report-filters__action-btn report-filters__action-btn--download-incentive"
              type="info"
              :disabled="!isClickDownloadWithIncentiveAsCSVDisabled"
              @click.prevent="handleClickDownloadWithIncentiveAsCSV"
            >
              Download (with Incentive)
            </el-button>
            <el-button
              class="report-filters__action-btn report-filters__action-btn--clear"
              plain
              type="danger"
              :disabled="!isClearDisabled"
              @click="handleClickClear"
            >ล้างค่า</el-button>
          </div>
        </div>
      </section>
      <div class="report-container">
        <div class="report-header">
          <div v-show="latest_update_time != null">
            <b>รายงานอัปเดต</b>
            <p>{{ latest_update_message }}</p>
          </div>
          <div class="report-header__summary">
            <p>{{ totalCount }}</p>
            <div class="top-page">
              <el-pagination
                background
                layout="prev, pager, next"
                :total="total"
                :disabled="!isPaginationDisable"
                :current-page="query.page"
                :page-size="30"
                @current-change="handleCurrentChange"
              ></el-pagination>
            </div>
          </div>
        </div>
        <div class="report-table">
          <div
            v-for="(report, index) in reportPresenters"
            :key="index"
            :class="{ header: index === 0 }"
            class="report-row"
          >
            <div class="report-subscription">
              <div
                v-for="(subscription, subscriptionIndex) in report.subscriptions"
                :key="subscriptionIndex"
                class="report-subscription-row"
              >
                <div class="report-subscription-histories">
                  <div
                    v-for="(history, historyIndex) in subscription.histories"
                    :key="historyIndex"
                    class="report-subscription-histories-row"
                  >
                    <div class="report-service">
                      <div
                        v-for="(service, indexService) in (history.services || [])"
                        :key="indexService"
                        class="report-service-row"
                      >
                        <div class="report-appointment">
                          <div
                            v-for="(
                              appointment, indexAppointment
                            ) in (service.appointments || [])"
                            :key="indexAppointment"
                            :class="[historyStatusClass(history.status)]"
                            class="report-appointment-row"
                          >
                            <div class="name report-cell">
                              {{ cell(history.order_number) }}
                            </div>
                            <div class="name report-cell">
                              {{ cell(history.user_id) }}
                            </div>
                            <div class="name report-cell">
                              {{ cell(history.name) }}
                            </div>
                            <div class="gender report-cell">
                              {{ cell(report.gender, "gender") }}
                            </div>
                            <div class="mobile-number report-cell">
                              {{ cell(report.mobile_number) }}
                            </div>
                            <div class="date-of-birth report-cell">
                              {{ cell(report.date_of_birth) }}
                            </div>
                            <div class="tax-id report-cell">
                              {{ cell(report.tax_id) }}
                            </div>
                            <div class="name report-cell">
                              {{ cell(subscription.project_name) }}
                            </div>
                            <div class="name report-cell">
                              {{ cell(subscription.address) }}
                            </div>
                            <div class="name report-cell">
                              {{ cell(subscription.package_id) }}
                            </div>
                            <div class="name report-cell">
                              <router-link
                                v-if="subscription.id && isRouterLinkDisabled"
                                :to="{
                                  name: 'SubscriberDetailPage',
                                  params: { id: subscription.id },
                                }"
                                target="_blank"
                                >{{ cell(subscription.package_name) }}</router-link
                              >
                              <span v-else>{{
                                cell(subscription.package_name)
                              }}</span>
                            </div>
                            <div class="name report-cell">
                              {{ cell(appointment.seller_trade) }}
                            </div>
                            <div class="name report-cell">
                              <pre class="report-group">{{
                                cell(subscription.group_name)
                              }}</pre>
                            </div>
                            <div class="name report-cell">
                              {{ cell(subscription.package_type) }}
                            </div>
                            <div class="name report-cell text-center status">
                              {{ cell(history.subscription_status) }}
                            </div>
                            <div class="name report-cell text-center status">
                              {{ cell(history.billing_status) }}
                            </div>
                            <div class="name report-cell text-center status">
                              {{ cell(history.actual_status) }}
                            </div>
                            <div class="report-cell text-center">
                              {{ cell(history.paid_on) }}
                            </div>
                            <div class="report-cell text-center">
                              {{ cell(history.time_paid_on) }}
                            </div>
                            <div class="report-cell text-center">
                              {{ cell(history.effectived_at) }}
                            </div>
                            <div class="report-cell text-center">
                              {{ cell(history.expired_at) }}
                            </div>
                            <div class="report-cell text-center">
                              {{ cell(appointment.main_option_title) }}
                            </div>
                            <div class="report-cell text-center">
                              {{ cell(appointment.extra_option_title) }}
                            </div>
                            <div class="report-cell text-center">
                              {{ cell(appointment.main_option_price, "number") }}
                            </div>
                            <div class="report-cell text-center">
                              {{ cell(appointment.extra_option_price, "number") }}
                            </div>
                            <div class="report-cell text-center">
                              {{ cell(appointment.quantity) }}
                            </div>
                            <div
                              v-if="indexService > 0 || indexAppointment > 0"
                              class="report-price-cell text-center"
                            ></div>
                            <div v-else class="report-first-price-cell text-center">
                              {{ cell(history.selling_price, "number") }}
                            </div>
                            <div
                              v-if="indexService > 0 || indexAppointment > 0"
                              class="report-price-cell text-center"
                            ></div>
                            <div v-else class="report-first-price-cell text-center">
                              {{ cell(history.coupon_code) }}
                            </div>
                            <div
                              v-if="indexService > 0 || indexAppointment > 0"
                              class="report-price-cell text-center"
                            ></div>
                            <div v-else class="report-first-price-cell text-center">
                              {{ cell(history.price, "number") }}
                            </div>
                            <div
                              v-if="indexService > 0 || indexAppointment > 0"
                              class="report-price-cell text-center"
                            ></div>
                            <div v-else class="report-first-price-cell text-center">
                              {{ cell(history.vat, "number") }}
                            </div>
                            <div
                              v-if="indexService > 0 || indexAppointment > 0"
                              class="report-price-cell text-center"
                            ></div>
                            <div v-else class="report-first-price-cell text-center">
                              {{ cell(history.price_with_out_vat, "number") }}
                            </div>
                            <div
                              v-if="indexService > 0 || indexAppointment > 0"
                              class="report-price-cell text-center"
                            ></div>
                            <div v-else class="report-first-price-cell text-center">
                              {{ cell(history.total_coin_amount, "number") }}
                            </div>
                            <div
                              v-if="indexService > 0 || indexAppointment > 0"
                              class="report-price-cell text-center"
                            ></div>
                            <div v-else class="report-first-price-cell text-center">
                              {{ cell(history.total_coin_price, "number") }}
                            </div>
                            <div
                              v-if="indexService > 0 || indexAppointment > 0"
                              class="report-price-cell text-center"
                            ></div>
                            <div v-else class="report-first-price-cell text-center">
                              {{ cell(history.income_before_mdr_vat, "number") }}
                            </div>
                            <div
                              v-if="indexService > 0 || indexAppointment > 0"
                              class="report-price-cell text-center"
                            ></div>
                            <div v-else class="report-first-price-cell text-center">
                              {{ cell(history.total_mdr, "number") }}
                            </div>
                            <div
                              v-if="indexService > 0 || indexAppointment > 0"
                              class="report-price-cell text-center"
                            ></div>
                            <div v-else class="report-first-price-cell text-center">
                              {{ cell(history.income_fee_rate_text) }}
                            </div>
                            <div
                              v-if="indexService > 0 || indexAppointment > 0"
                              class="report-price-cell text-center"
                            ></div>
                            <div v-else class="report-first-price-cell text-center">
                              {{ cell(history.net_fee, "number") }}
                            </div>
                            <div
                              v-if="indexService > 0 || indexAppointment > 0"
                              class="report-price-cell text-center"
                            ></div>
                            <div v-else class="report-first-price-cell text-center">
                              {{ cell(history.income, "number") }}
                            </div>
                            <div class="report-cell text-end">
                              <a
v-if="history.receipt_bank_transfer"
                                :href="history.receipt_bank_transfer"
                                target="_blank"
                                >{{
                                  cell(history.payment_channel)
                                }}</a>
                              <span v-else>{{
                                cell(history.payment_channel)
                              }}</span>
                            </div>
                            <div class="report-cell text-center">
                              <router-link
                                :to="{
                                  name: 'ReceiptDetailPage',
                                  params: {
                                    id: history.credit_note_document_number_id,
                                  },
                                }"
                                target="_blank"
                                >{{
                                  cell(
                                    history.credit_note_document_number ||
                                      history.credit_note_document_number_id
                                  )
                                }}</router-link
                              >
                            </div>
                            <div class="report-cell text-start">
                              {{ cell(history.refund_remark) }}
                            </div>
                            <div class="report-cell text-start">
                              <pre class="report-billing">{{
                                cell(history.bill_address)
                              }}</pre>
                            </div>
                            <div class="report-cell text-center">
                              <router-link
                                v-if="appointment.receipt_id"
                                :to="{
                                  name: 'ReceiptDetailPage',
                                  params: { id: appointment.receipt_id },
                                }"
                                target="_blank"
                                >{{
                                  cell(
                                    appointment.receipt_document_number ||
                                      appointment.receipt_id
                                  )
                                }}</router-link
                              >
                              <span v-else>{{
                                cell(appointment.receipt_document_number)
                              }}</span>
                            </div>
                            
                            <div class="report-cell">
                              {{ cell(serviceCellLabel(appointment, service)) }}
                            </div>
                            <div class="report-cell">
                              {{ cell(appointment.provider_name) }}
                            </div>
                            <div class="report-cell">
                              {{ cell(appointment.provider_name_on_sap) }}
                            </div>
                            <div class="report-cell">
                              {{ cell(appointment.sap_service_type) }}
                            </div>
                            <div class="report-cell">
                              {{ cell(appointment.provider_name_by_appointment) }}
                            </div>
                            <div class="report-cell">
                              {{ cell(appointment.cost_before_vat, "number") }}
                            </div>
                            <div class="report-cell">
                              {{ cell(appointment.cost, "number") }}
                            </div>
                            <div class="report-cell text-center">
                              <router-link
                                v-if="appointment.is_appointment_have_remark"
                                :to="{
                                  name: 'AppointmentDetailPage',
                                  params: { id: appointment.id },
                                }"
                                target="_blank"
                                >Remarks</router-link
                              >
                            </div>
                            <div class="report-cell text-center">
                              {{ cell(appointment.booked_on) }}
                            </div>
                            <div class="report-cell text-center">
                              <router-link
                                v-if="appointment.id"
                                :to="{
                                  name: 'AppointmentDetailPage',
                                  params: { id: appointment.id },
                                }"
                                target="_blank"
                                >{{ cell(appointment.appointment_date) }}</router-link
                              >
                              <span v-else>{{
                                cell(appointment.appointment_date)
                              }}</span>
                            </div>
                            <div class="report-cell text-center">
                              {{ cell(appointment.period_appointment_date_time) }}
                            </div>
                            <div class="report-cell text-center">
                              {{ cell(appointment.confirmed) }}
                            </div>
                            <div class="report-cell text-center">
                              {{ cell(appointment.used) }}
                            </div>
                            <div class="report-cell text-center">
                              {{ cell(appointment.fulfilled_at) }}
                            </div>
                            <div class="report-cell text-end">
                              {{ cell(history.ref_code) }}
                            </div>
                            <div class="report-cell text-center">
                              {{ cell(appointment.receipt_date) }}
                            </div>
                            <div class="report-cell text-center">
                              {{ cell(appointment.receipt_number) }}
                            </div>
                            <div class="report-cell text-center">
                              {{ cell(appointment.actual_cost, "number") }}
                            </div>
                            <div class="report-cell">
                              {{ cell(history.note) }}
                            </div>
                            <div class="report-cell">
                              {{ cell(appointment.maintenance_request) }}
                            </div>
                            <div class="report-cell">
                              {{ cell(appointment.po_number) }}
                            </div>
                            <div class="report-cell">
                              {{ cell(appointment.sap_cost, "number") }}
                            </div>
                            <div
                              v-if="indexService > 0 || indexAppointment > 0"
                              class="report-price-cell text-center"
                            ></div>
                            <div v-else class="report-first-price-cell text-center">
                              {{ cell(history.wallet_name) }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="wrapper page">
          <el-pagination
            :total="total"
            :current-page="query.page"
            :page-size="30"
            background
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </div>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import DatePicker from "@/lib/components/DatePicker";
import { DateTime } from "luxon";
import PageWrapper from "@/lib/components/PageWrapper";
import { baanRueJaiClient } from "@/dependencies";
import { toLocaleTH } from "@/lib/dateTime";
import {
  Select,
  Option,
  Input,
  Pagination,
  Checkbox,
  Button
} from "element-ui";
import { convertCsvToExcelBuffer } from "@/lib/util"
import ProjectSelect from "@/lib/components/ProjectSelect";
import LoadingOverlay from "@/lib/components/LoadingOverlay";
import { formatNumber } from "@/lib/formatter";
import { genderMapper } from "@/lib/mapper";

export default {
  components: {
    PageWrapper,
    DatePicker,
    "el-select": Select,
    "el-option": Option,
    "el-input": Input,
    ProjectSelect,
    LoadingOverlay,
    "el-pagination": Pagination,
    "el-checkbox": Checkbox,
    "el-button": Button
  },
  data() {
    const filterDate = [
      { label: "ทั้งหมด", value: "" },
      { label: "วันชำระ", value: "paidOn" },
      { label: "วันนัด", value: "appointmentDate" },
      { label: "วันสิ้นสุด", value: "expiredAt" },
      { label: "ใช้เมื่อ", value: "used" },
      { label: "วันที่ใบเสร็จจาก vendor", value: "vendorReceipt" },
      { label: "วันปิดงาน", value: "fulfilled" }
    ];
    const filterStatus = [
      { label: "ทั้งหมด", value: "" },
      { label: "Active", value: "active" },
      { label: "Cancelled", value: "cancelled" },
      { label: "Unsubscribed", value: "unsubscribed" },
      { label: "Expired", value: "expired" }
    ];
    const filterType = [
      { label: "ทั้งหมด", value: "" },
      { label: "Free Trial", value: "freeTrial" },
      { label: "One Time", value: "oneTime" },
      { label: "Subscribe", value: "subscribe" }
    ];
    const filterCategory = [
      { label: "ทั้งหมด", value: "" },
      { label: "Home Expert", value: "Home Expert" },
      { label: "Life Style", value: "Lifestyle" },
      { label: "Subscription", value: "Subscription" },
      { label: "Ruejai Club", value: "Ruejai Club" },
      { label: "RJB2B", value: "RJB2B" }
    ];
    const filterReceiptType = [
      { label: "ทั้งหมด", value: "" },
      { label: "ใบเสร็จรับเงิน/ใบกำกับภาษี", value: "RECEIPT_AND_TAX_INVOICE" },
      { label: "ใบกำกับภาษี", value: "TAX_INVOICE" },
      { label: "ใบลดหนี้", value: "CREDIT_NOTE" },
    ]
    const filterCompanyType = [
      { label: "ทั้งหมด", value: "" },
      { label: "SC Asset", value: "SC_ASSET" },
      { label: "SC Able", value: "SC_ABLE" }
    ]

    return {
      searchProjectResult: [],
      reports: [],
      dateRange: [],
      filterDate,
      filterStatus,
      filterType,
      filterCategory,
      query: {},
      selectedProject: null,
      filterReceiptType,
      filterCompanyType,
      total: 0,
      isClearDisabled: true,
      isSearchDisabled: true,
      isClickDownloadAsCSVDisabled: true,
      isClickDownloadWithIncentiveAsCSVDisabled: true,
      isPaginationDisable: true,
      isDropdownDisabled: true,
      isRouterLinkDisabled:true,
      isFilteredByMNC: false,
      isLoading: false,
      latest_update_time: null
    };
  },
  computed: {
    reportPresenters() {
      const header = {
        user_id: "User ID",
        gender: "เพศ",
        mobile_number: "เบอร์ติดต่อ",
        date_of_birth: "ปีเกิด",
        tax_id: "Tax ID",
        subscriptions: [
          {
            address: "ที่อยู่",
            package_name: "แพ็กเกจ",
            package_id: "Package ID",
            package_price: "ราคา",
            project_name: "โครงการ",
            histories: [
              {
                order_number: "ลำดับ",
                user_id: "User ID",
                paid_on: "วันชำระ",
                time_paid_on: "เวลาที่ชำระ",
                effectived_at: "วันเริ่ม",
                expired_at: "วันสิ้นสุด",
                price: "ราคาขายสุทธิ (รวม VAT)",
                price_with_out_vat: "ราคาขาย (ก่อน VAT)",
                vat: "VAT",
                total_mdr: "MDR+VAT",
                income_fee_rate_text: "อัตราค่าธรรมเนียม",
                net_fee: "ค่าธรรมเนียมสุทธิ",
                income: "เงินรับสุทธิ",
                payment_channel: "ช่องทางการชำระเงิน",
                credit_note_document_number_id: "เลขที่ใบลดหนี้",
                actived: "ACTIVED",
                bill_address: "ข้อมูลที่ใช้ออกใบเสร็จ",
                coupon_code: "ส่วนลด",
                ref_code: "รหัสอ้างอิง",
                selling_price: "ราคาขาย (รวม VAT)",
                total_coin_amount: "จำนวน MNC (MNC)",
                total_coin_price: "มูลค่า MNC (บาท)",
                wallet_name: "Wallet Name",
                income_before_mdr_vat: "เงินรับสุทธิก่อน (MDR+VAT)",
                note: "หมายเหตุ",
                status: "สถานะ",
                name: "ชื่อ",
                services: [
                  {
                    name: "บริการ",
                    appointments: [
                      {
                        is_appointment_have_remark: 'Appointment Remarks',
                        cost: "ต้นทุนประมาณการ (หลัง Vat)",
                        booked_on: "นัดเมื่อ",
                        appointment_date: "วันนัด",
                        confirmed: "Confirmed",
                        main_option_title: "Option หลัก",
                        extra_option_title: "Optiong เสริม",
                        main_option_price: "ราคา Option หลัก",
                        extra_option_price: "ราคา Option เสริม",
                        quantity: "จำนวนต่อ Package",
                        used: "ใช้เมื่อ",
                        receipt_date: "วันที่ใบเสร็จจากVendor",
                        receipt_number: "เลขที่ใบเสร็จจากVendor",
                        actual_cost: "ต้นทุนจริง",
                        receipt_document_number: "เลขที่ใบเสร็จ",
                        cost_before_vat: "ต้นทุนประมาณการ (ก่อน Vat)",
                        seller_trade: "บริษัท",
                        fulfilled_at: "ปิดงาน",
                        maintenance_request: "เลขที่ใบแจ้งซ่อม",
                        provider_name: "ผู้ให้บริการ",
                        provider_name_on_sap: "ชื่อผู้ให้บริการบน sap",
                        period_appointment_date_time: "เวลานัด",
                        provider_name_by_appointment: "ชื่อผู้ให้บริการรายนัดหมาย",
                        sap_service_type: "ประเภทของสินค้าและบริการ (SAP)",
                        po_number: "PO_NUMBER",
                        sap_cost: "ราคาต้นทุนที่ส่ง sap"
                      }
                    ]
                  }
                ],
                refund_remark: "Remark ของ Refund",
                subscription_status: "สถานะ Transaction",
                billing_status: "สถานะตามรอบบิล",
                actual_status: "สถานะตามจริง"
              }
            ],
            group_name: "หมวดหมู่",
            package_type: "ประเภท",
            cancelled_at: "ยกเลิกเมื่อ",
            is_free_trial: "ทดลองใช้"
          }
        ]
      };

      return [header, ...this.reports];
    },
    queryParams() {
      const {
        from,
        to,
        dateType,
        status,
        type,
        category,
        selectedProject,
        receiptTypeTH,
        companyType,
        page,
        documentNumber,
        isFilteredByMNC
      } = this.$route.query;

      return {
        from,
        to,
        dateType,
        status,
        type,
        category,
        selectedProject,
        receiptTypeTH,
        companyType,
        page: page && +page || 1,
        documentNumber,
        isFilteredByMNC
      };
    },
    totalCount() {
      if (!this.total || this.total === 0) {
        return "ไม่พบข้อมูล";
      }
      const limit = 30;
      const currentTotalItem = this.reports.reduce(
        (total, user) =>
          total +
          (user.subscriptions || []).reduce(
            (all, current) => all + (current.histories || []).length,
            0
          ),
        0
      );

      const isLastPage = limit > currentTotalItem;
      const currentPage = this.query.page || 1;
      const endNum = isLastPage ? this.total : currentPage * limit;
      const startNum = (isLastPage ? limit * currentPage - limit : endNum - limit) + 1;

      return `แสดงผล ${startNum.toLocaleString()} - ${endNum.toLocaleString()} จากทั้งหมด ${this.total.toLocaleString()}`;
    },
    latest_update_message() {
      const format = "อัปเดตล่าสุดเมื่อวันที่ dd MMMM yyyy เวลา HH:mm น.";

      return toLocaleTH(
        DateTime.fromISO(this.latest_update_time)
      ).toFormat(format);
    }
  },
  watch: {
    "$route.query": function onRouteQueryChange() {
      this.setupForm();
      this.setupData();

      this.$refs.pageEl.$el.querySelector(".page-content").scrollTop = 0;
    },
    dateRange(newValue, oldValue) {
      if (!newValue) {
        return
      }

      const [from, to] = newValue;

      if (to.minus({ days: 93 }) > from) {
        this.$message.error('ไม่สามารถเลือกเกิน 3 เดือนได้');
        this.dateRange = oldValue;
      }
    }
  },
  mounted() {
    if (typeof ResizeObserver === "undefined") {
      this.syncReportColumnWidths();
      return;
    }

    // Watch for Resize Column Width
    this.reportResizeObserver = new ResizeObserver(() => {
      this.scheduleSyncReportColumnWidths();
    });

    // Start Observer When Mounted
    this.$nextTick(() => {
      const table = this.$el?.querySelector(".report-table");
      if (table) {
        this.reportResizeObserver.observe(table);
      }
    });
  },
  beforeDestroy() {
    this.reportResizeObserver?.disconnect();
    clearTimeout(this.syncReportColumnsTimer);
  },
  created() {
    this.setup();
  },
  methods: {
    cell(value, format) {
      if (value === null || value === undefined) {
        return "-";
      }

      if (typeof value === "string" && value.trim() === "") {
        return "-";
      }

      if (format === "gender") {
        const genderKey = String(value).trim().toLowerCase();
        return genderMapper[genderKey] || value;
      }

      if (format === "number") {
        return this.formatReportNumber(value);
      }

      return value;
    },
    formatReportNumber(value) {
      const normalized = typeof value === "string"
        ? value.replace(/,/g, "").trim()
        : value;

      const num = Number(normalized);

      if (Number.isNaN(num)) {
        return value;
      }

      const fractionDigits = Number.isInteger(num) ? 0 : 2;

      return formatNumber(num, fractionDigits);
    },
    serviceCellLabel(appointment, service) {
      const prefix =
        appointment.appointment_no && appointment.appointment_count
          ? `(${appointment.appointment_no}/${appointment.appointment_count}) `
          : "";

      return `${prefix}${service.name || ""}`;
    },
    setup() {
      this.setupForm();
      this.setupData();
    },
    setupForm() {
      const { from, to, isFilteredByMNC } = this.$route.query;

      this.query = {
        dateType: this.$route.query.dateType || null,
        type: this.$route.query.type || null,
        status: this.$route.query.status || null,
        category: this.$route.query.category || null,
        selectedProject: this.$route.query.selectedProject || null,
        receiptTypeTH: this.$route.query.receiptTypeTH || null,
        companyType: this.$route.query.companyType || null,
        page: this.$route.query.page && this.$route.query.page !== ''
          ? +this.$route.query.page || 1
          : 1,
        documentNumber: this.$route.query.documentNumber || null
      };

      if (from && to) {
        this.dateRange = [DateTime.fromISO(from), DateTime.fromISO(to)];
      } else if (!this.query.documentNumber) {
        const formDateTime = DateTime.utc().setZone('utc+7').startOf('day')
        const toDateTime = formDateTime.endOf('day')

        this.dateRange = [formDateTime, toDateTime];
      }
      this.isFilteredByMNC = (/true/).test(isFilteredByMNC)
    },
    setupData() {
      this.setupReports();
    },
    async setupReports() {
      const result = await this.fetchReports();
      if (!result) return;

      this.reports = result?.reports ?? [];
      this.total = result?.total ?? 0;
      this.latest_update_time = result?.timestamp ?? null;

      this.isAbleButton();
      this.syncReportColumnWidths();
    },
    scheduleSyncReportColumnWidths() {
      clearTimeout(this.syncReportColumnsTimer);

      this.syncReportColumnsTimer = setTimeout(
        () => this.syncReportColumnWidths(),
        100
      );
    },
    syncReportColumnWidths() {
      this.$nextTick(() => {
        const table = this.$el?.querySelector(".report-table");
        if (!table) {
          return;
        }

        const rows = table.querySelectorAll(".report-appointment-row");
        if (!rows.length) {
          return;
        }

        const colCount = rows[0].children.length;
        const maxWidths = Array(colCount).fill(0);
        const colMax = 300;
        const colMin = 80;
        const rowSampleSize = 30;
        const stickyColMins = [85, 70];
        const rowsToMeasure = Array.from(rows).slice(0, rowSampleSize);

        rowsToMeasure.forEach((row) => {
          Array.from(row.children).forEach((cell, index) => {
            const minWidth = stickyColMins[index] || colMin;
            const width = Math.ceil(
              Math.max(
                cell.scrollWidth,
                cell.offsetWidth,
                cell.getBoundingClientRect().width
              )
            );
            maxWidths[index] = Math.max(maxWidths[index], width, minWidth);
          });
        });

        const template = maxWidths
          .map((width) => `${Math.min(width, colMax)}px`)
          .join(" ");

        table.style.setProperty(
          "--sticky-col-2-left",
          `${Math.min(maxWidths[0], colMax)}px`
        );

        rows.forEach((row) => {
          // eslint-disable-next-line no-param-reassign -- intentional DOM style mutation on the actual row element
          row.style.gridTemplateColumns = template;
        });
      });
    },
    async fetchReports() {
      const emptyResult = { reports: [], total: 0, timestamp: null };
      this.isLoading = true;

      try {
        const response = await baanRueJaiClient.admin.subscriptions.getReports(
          this.queryParams
        );

        return response?.data?.result ?? emptyResult;
      } catch (error) {
        this.reports = [];
        this.total = 0;
        const message = error.response
          ? error.response.data.message
          : error.message;
        this.$message.error(
          `ไม่สามารถดู Report ได้เนื่องจาก${message ? ` ${message}` : "ไม่พบข้อมูล"}`
        );
        this.isAbleButton();

        return emptyResult;
      } finally {
        this.isLoading = false;
      }
    },
    historyStatusClass(status) {
      return status ? String(status).toLowerCase() : "";
    },
    handleClickSearch() {
      const from = this.dateRange && this.dateRange.length > 1
        ? this.dateRange[0].toISO()
        : undefined

      const to = this.dateRange && this.dateRange.length > 1
        ? this.dateRange[1].toISO()
        : undefined

      const query = {
        from,
        to,
        dateType: this.query.dateType,
        status: this.query.status,
        type: this.query.type,
        category: this.query.category,
        selectedProject: this.selectedProject,
        receiptTypeTH: this.query.receiptTypeTH,
        companyType: this.query.companyType,
        page: 1,
        documentNumber: this.query.documentNumber
      };

      if (this.isFilteredByMNC) {
        query.isFilteredByMNC = this.isFilteredByMNC;
      }

      this.$router.push({ query });
      this.isDisableButton();
    },
    cloneWithEmpty(obj) {
      return Object.keys(obj).reduce((all, key) => ({ ...all, [key]: "" }), {});
    },
    async handleClickDownloadAsCSV(event) {
      event.preventDefault();
      this.isDisableButton();
      this.isLoading = true;
      try {
        const response = await baanRueJaiClient.admin.subscriptions.getReports({
          ...this.queryParams,
          format: "csv"
        });

        const excelBuffer = convertCsvToExcelBuffer(response.data);

        const blob = new Blob([excelBuffer]);
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `subscription-reports.xlsx`;
        link.click();
      } finally {
        this.isLoading = false;
        this.isAbleButton();
      }
    },
    async handleClickDownloadWithIncentiveAsCSV(event) {
      event.preventDefault();
      this.isDisableButton();
      this.isLoading = true;
      try {
        const response = await baanRueJaiClient.admin.subscriptions.getReports({
          ...this.queryParams,
          incentiveflag: true,
          format: "csv"
        });

        const excelBuffer = convertCsvToExcelBuffer(response.data);

        const blob = new Blob([excelBuffer]);
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `subscription-incentive-reports.xlsx`;
        link.click();
      } finally {
        this.isLoading = false;
        this.isAbleButton();
      }
    },
    handleClickClear() {
      this.query.dateType = "";
      this.query.status = "";
      this.query.type = "";
      this.query.category = "";
      this.selectedProject = "";
      this.query.receiptTypeTH = "";
      this.query.companyType = "";
      this.query.page = 1;
      this.query.documentNumber = "";
      this.query.isFilteredByMNC = "";
    },
    handleCurrentChange(page) {
      this.isDisableButton();
      const query = { ...this.$route.query, page }

      this.$router.push({ query });
    },
    setReportControlsEnabled(isEnabled) {
      [
        "isSearchDisabled",
        "isClearDisabled",
        "isClickDownloadAsCSVDisabled",
        "isClickDownloadWithIncentiveAsCSVDisabled",
        "isPaginationDisable",
        "isDropdownDisabled",
        "isRouterLinkDisabled"
      ].forEach((key) => {
        this[key] = isEnabled;
      });
    },
    isDisableButton() {
      this.setReportControlsEnabled(false);
    },
    isAbleButton() {
      this.setReportControlsEnabled(true);
    },
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

// Must match the number of direct children on each .report-appointment-row
$report-column-count: 66;
$report-col-min: 80px;
$report-col-max: 300px;
$sticky-col-1: 85px;
$sticky-col-2: 70px;
$table-border-color: #d4d9e2;
$table-header-bg: #f5f7fa;
$table-stripe-bg: #fafafa;

.report-container {
  padding: 20px 0;
  width: 100%;
  max-width: 100%;
  min-width: 0;
}

.report-table {
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  width: 100%;
  max-width: 100%;
  max-height: calc(100vh - 320px);
  min-width: 0;
  box-sizing: border-box;
  border: 1px solid $table-border-color;
  background: #fff;
  scroll-padding-inline-end: 1.5rem;
}

.report-row {
  display: block;
  width: max-content;
}

.report-first-price-cell,
.report-price-cell,
.report-cell {
  font: inherit;
  padding: 0.5rem 0.65rem;
  min-width: 0;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.report-subscription {
  border-left: 1px solid $table-border-color;
  border-bottom: 1px solid $table-border-color;
}

.report-subscription-row,
.report-subscription-histories-row,
.report-service-row,
.report-appointment-row {
  display: grid;
  align-items: stretch;
  width: max-content;
}

.report-subscription,
.report-subscription-histories,
.report-service,
.report-appointment {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  width: max-content;
}

.report-appointment {
  border-left: 1px solid $table-border-color;
}

.report-appointment-row {
  box-sizing: content-box;
  width: max-content;
  grid-template-columns:
    $sticky-col-1
    $sticky-col-2
    repeat(
      $report-column-count - 2,
      minmax($report-col-min, max-content)
    );

  // Sticky first and second column
  > .report-cell:nth-child(1) {
    left: 0;
    white-space: nowrap;
  }

  // The second column is sticky with left offset equal to the width of the first column
  > .report-cell:nth-child(2) {
    left: var(--sticky-col-2-left);
  }

  > .report-cell:nth-child(-n + 2) {
    position: sticky;
    z-index: 2;
    background: #fff;
  }

  > :last-child {
    border-right: 1px solid $table-border-color;
  }

  &.cancelled,
  &.unsubscribed,
  &.one_time,
  &.free_trial {
    background: $table-stripe-bg;

    > .report-cell:nth-child(-n + 2) {
      background: $table-stripe-bg;
    }

    > .status {
      font-weight: bold;
    }
  }

  &.cancelled {
    > .status {
      color: $danger-color;
    }
  }

  &.unsubscribed {
    > .status {
      color: $warning-color;
    }
  }

  &.free_trial {
    > .status {
      color: $secondary-color;
    }
  }

  &.one_time {
    > .status {
      color: $primary-color;
    }
  }
}

.page-container {
  padding: 15px;
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow-x: hidden;
}

.report-filter {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  display: flex;
  justify-content: center;
}

.report-filter .form {
  width: 100%;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.form .section {
  display: grid;
  gap: 0.75rem 1rem;
  margin-top: 0.5rem;
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.report-filters__field--span-2 {
  grid-column: span 2;
}

.report-filters__field--full {
  grid-column: 1 / -1;
}

.report-filters__field {
  min-width: 0;
}

.label {
  font-size: .9rem;
  margin-bottom: .25rem;
}

.report-filters__control {
  width: 100%;
}

.report-filters__field ::v-deep .el-select,
.report-filters__field ::v-deep .el-input,
.report-filters__field ::v-deep .el-date-editor {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

.report-filters__options {
  text-align: center;
}

.report-filters__options .checkbox-font {
  margin: 0;
}

.report-filters__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  max-width: 100%;
}

@media (max-width: 1199px) {
  .report-filter .form {
    width: 100%;
  }

  .form .section {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.report-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.report-header p {
  margin: 0;
}

.report-header__summary {
  text-align: right;
}

.top-page {
  text-align: right;
  padding-top: 0.5rem;
  max-width: 100%;
  min-width: 0;
  overflow-x: auto;
}

@media (max-width: 640px) {
  .form .section {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .report-filter {
    margin-bottom: 1rem;
  }

  .report-filters__actions {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    align-items: stretch;
  }

  .report-filters__actions .el-button {
    width: 100%;
    margin-left: 0;
  }

  .report-filters__action-btn--search {
    order: 1;
  }

  .report-filters__action-btn--clear {
    order: 2;
  }

  .report-filters__action-btn--download {
    order: 3;
  }

  .report-filters__action-btn--download-incentive {
    order: 4;
  }

  .report-header {
    align-items: stretch;
    flex-direction: column;
  }

  .report-header__summary,
  .top-page {
    text-align: left;
  }
}

@media (max-width: 420px) {
  .form .section {
    grid-template-columns: 1fr;
  }

  .report-filters__field--span-2 {
    grid-column: auto;
  }
}

.report-row:first-child {
  position: sticky;
  top: 0;
  z-index: 5;

  .report-first-price-cell,
  .report-price-cell,
  .report-cell {
    border-top: 1px solid $table-border-color;
    font-weight: bold;
    text-align: left !important;
    background: $table-header-bg;
  }

  // The first two columns of the first row should be above the rest of the rows
  .report-appointment-row > .report-cell:nth-child(-n + 2) {
    z-index: 6;
    background: $table-header-bg;
  }
}

.report-row:not(:first-child) {
  .report-first-price-cell,
  .report-price-cell,
  .report-cell {
    text-align: left !important;
  }
}

.report-cell {
  a {
    text-decoration: underline;
  }

  border-bottom: 1px solid $table-border-color;

  &:not(:first-child) {
    border-left: 1px solid $table-border-color;
  }

  &:empty::before {
    content: "-";
    color: #d8d8d8;
  }
}

.report-first-price-cell {
  &:empty::before {
    content: "-";
    color: #d8d8d8;
  }
}

.report-first-price-cell,
.report-price-cell {
  &:not(:first-child) {
    border-left: 1px solid $table-border-color;
  }
}

.report-first-price-cell {
  &:not(:first-child) {
    border-top: 1px solid $table-border-color;
  }
}

pre.report-group,
pre.report-billing {
  white-space: pre-wrap;
  word-wrap: break-word;
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  color: inherit;
}

.page {
  padding-top: 15px;
  text-align: right;
}

</style>

<style lang="scss">
.subscriber-report-page.page-wrapper {
  flex: 1 1 auto;
  font-family: inherit;
  font-size: 14px;
  line-height: 1.5;
  min-width: 0;
  width: calc(100vw - 240px);
  max-width: calc(100vw - 240px);
  overflow: hidden;
}

.subscriber-report-page .page-content {
  min-width: 0;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
}

@media (max-width: 768px) {
  .subscriber-report-page.page-wrapper {
    width: 100vw;
    max-width: 100vw;
  }
}
</style>
